'use client'

import type { ComponentProps } from 'react'
import ReactFullPage from '@fullpage/react-fullpage'

import type { Sections } from 'views/HomePage/types'


const sectionBaseClassName = 'sm:h-screen min-h-screen relative z-10 overflow-y-auto section'
const credits = {
  enabled: false,
}

type DesktopViewProps = {
  sections: Sections
}

const Desktop: React.FC<DesktopViewProps> = (props) => {
  const { sections } = props

  const render: ComponentProps<typeof ReactFullPage>['render'] = () => {
    return (
      <ReactFullPage.Wrapper>
        {
          sections.map(({ anchor, Component }) => {
            return (
              <Component key={anchor} className={sectionBaseClassName} />
            )
          })
        }
      </ReactFullPage.Wrapper>
    )
  }

  return (
    <ReactFullPage
      licenseKey="MM47I-2KRXI-13FKK-KJ3SI-XDNYN"
      anchors={sections.map(({ anchor }) => anchor)}
      sectionSelector=".section"
      scrollBar={false}
      scrollOverflowMacStyle={false}
      scrollOverflowReset
      keyboardScrolling
      scrollingSpeed={600}
      credits={credits}
      render={render}
      navigation
      css3
    />
  )
}

export default Desktop
